module.exports = __webpack_public_path__ + "static/media/wedge-connector.765aec3e.webp";